import { useState, type ReactNode } from "react";
import { PartnerBundleDialog } from "./PartnerBundleDialog";
import type { Partner } from "./partners";

/**
 * Every control that starts a partner enquiry, so all of them behave the same.
 *
 * It is a `<button>`, not a `<Link>`, and that is the point: the click opens a
 * dialog rather than navigating, and a link that does not navigate is a lie to
 * anyone using a screen reader, middle-clicking, or reading the status bar. The
 * navigation still happens — from inside the dialog, once the reader has seen
 * the bundle offer.
 *
 * `className` carries the marketing button classes so it sits in a `.hero-cta`
 * or a `.cta` exactly as the anchor it replaced did.
 */
export function PartnerCta({
  partner, className, children,
}: {
  partner: Partner;
  className?: string;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        className={className}
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen(true)}
      >
        {children}
      </button>
      {open && <PartnerBundleDialog partner={partner} onClose={() => setOpen(false)} />}
    </>
  );
}
